/**
 * Distinct values of a column across rows, coerced to strings — the shared
 * basis for category sets (grouped charts) and the editor's per-category
 * controls. Centralizes the `String()` coercion so every consumer treats
 * categories the same way.
 */
import type { DataPoint } from '../../types/dashboard';

export function uniqueValues(rows: DataPoint[], key: string): string[] {
  return Array.from(new Set(rows.map((r) => String(r[key]))));
}
